// Mutations will be refactored into modules at a later time

import initialState from './state'

export const setPerPage = function (state, perPage) {
  state.perPage = perPage
}

export const setCurrentUser = function (state, user) {
  state.currentUser = user
}

export const setStatuses = function (state, statuses) {
  state.statuses = statuses
}

export const setCurrentCompany = function (state, companyId) {
  state.currentCompany = companyId
}

export const setWorkOrderStatus = function (state, workOrderStatus) {
  state.workOrderStatus = workOrderStatus
}

export const setPicklistStatus = function (state, picklistStatus) {
  state.picklistStatus = picklistStatus
}

export const setPicklistUnits = function (state, picklistUnits) {
  state.picklistUnits = picklistUnits
}

export const setWorkOrderUnit = function (state, workOrderUnit) {
  state.workOrderUnit = workOrderUnit
}

export const setWorkOrderResponsible = function (state, workOrderResponsible) {
  state.workOrderResponsible = workOrderResponsible
}

export const setResponsibleSeller = function (state, responsibleSeller) {
  state.responsibleSeller = responsibleSeller
}

export const setSelectedFlataRows = function (state, flataRows) {
  state.selectedFlataRows = flataRows
}

export const updateSelectedFlataRows = function (state, params) {
  var idx = state.selectedFlataRows.map(object => object.id).indexOf(params.id)
  state.selectedFlataRows[idx][params.field] = params.value
}

export const setSelectedFlata = function (state, flata) {
  state.selectedFlata = flata
}

export const removeSelectedFlataRows = function (state, id) {
  state.selectedFlataRows = state.selectedFlataRows.filter(function (x) {
    if (x.id !== id) {
      return x
    }
  })
}

export const removeSelectedFlata = function (state, id) {
  state.selectedFlata = state.selectedFlata.filter(function (x) {
    if (x !== id) {
      return x
    }
  })
}

export const setCurrentReport = function (state, data) {
  data.comment = ''
  if (state.currentCompany in state.currentReports) {
    if (!state.currentReports[state.currentCompany].find(o => o.joint_id === data.joint_id)) {
      var newArr = state.currentReports[state.currentCompany]
      newArr.push(data)
      state.currentReports = Object.assign({}, state.currentReports, {
        [state.currentCompany]: newArr
      })
      setSelectedReportRows(state, data.joint_id)
    }
  } else {
    state.currentReports = Object.assign({}, state.currentReports, {
      [state.currentCompany]: data
    })
    setSelectedReportRows(state, data.joint_id)
  }
}

export const setCurrentReportComment = function (state, data) {
  state.currentReports[state.currentCompany][data.idx].comment = data.comment
}

export const setCurrentReportOperatorId = function (state, data) {
  state.currentReports[state.currentCompany][data.idx].oper_id = data.oper_id
}

export const setCurrentReportDateTime = function (state, data) {
  state.currentReports[state.currentCompany][data.idx].datetime = data.datetime
}

export const setCurrentReportName = function (state, data) {
  state.currentReportName = data
}

export const setCurrentReportsDefaults = function (state, companies) {
  companies.forEach(function (c) {
    state.currentReports = Object.assign({}, state.currentReports, {
      [c.id]: []
    })
  })
}

export const clearCurrentReport = function (state) {
  state.currentReports = Object.assign({}, state.currentReports, {
    [state.currentCompany]: []
  })
  state.currentReportName = ''
  clearSelectedReportRows(state)
}

export const removeCurrentReportEntry = function (state, jointId) {
  state.currentReports = Object.assign({}, state.currentReports, {
    [state.currentCompany]: state.currentReports[state.currentCompany].filter(function (x) {
      if (x.joint_id !== jointId) {
        return x
      }
    })
  })
}

export const setSelectedReportRows = function (state, jointId) {
  state.selectedReportRows[state.currentCompany].push(jointId)
}

export const clearSelectedReportRows = function (state) {
  state.selectedReportRows[state.currentCompany] = []
}

export const setSelectedReportRowsDefaults = function (state, companies) {
  companies.forEach(function (c) {
    state.selectedReportRows = Object.assign({}, state.selectedReportRows, {
      [c.id]: []
    })
  })
}

export const setRouteDataDefaults = function (state, routes) {
  routes.forEach(function (c) {
    state.routeData = Object.assign({}, state.routeData, {
      [c.name]: {
        filters: {
          date: [],
          equipment_type: [],
          current_rentals: null,
          search: '',
          id_interval: [],
          equipment_id: null,
          status: null,
          show_hidden_equipment: null,
          hide_archived: null
        }
      }
    })

    if (typeof c.children !== 'undefined') {
      c.children.forEach(function (b) {
        state.routeData = Object.assign({}, state.routeData, {
          [b.name]: {
            filters: {
              date: [],
              equipment_type: [],
              current_rentals: null,
              search: '',
              id_interval: [],
              equipment_id: null,
              status: null,
              hide_archived: null,
              show_hidden_equipment: null
            }
          }
        })
      })
    }
  })
}

export const setRouteFilterData = function (state, params) {
  state.routeData[params.routeName]['filters'] = Object.assign({}, state.routeData[params.routeName]['filters'], {
    [params.filterType]: params.value
  })
}

export const removeSelectedReportRowsEntry = function (state, jointId) {
  const filteredRows = state.selectedReportRows[state.currentCompany].filter(x => x !== jointId)
  const newSelectedReportRows = {...state.selectedReportRows}
  newSelectedReportRows[state.currentCompany] = filteredRows
  state.selectedReportRows = newSelectedReportRows
}

export const resetState = function (s) {
  const initial = initialState
  Object.keys(initial).forEach(key => { s[key] = initial[key] })
  s.currentReports = {}
}

export const setStockMode = function (state, mode) {
  state.stockMode = mode
}

export const setStockQueue = function (state, queue) {
  state.stockQueue = queue
}

export const clearStockState = function (state) {
  state.stockMode = null
  state.stockQueue = []
}

export const setNewReportStep = function (state, step) {
  state.newReport = Object.assign({}, state.newReport, { currentStep: step })
}

export const setNewReportHeader = function (state, header) {
  state.newReport = Object.assign({}, state.newReport, {
    header: Object.assign({}, state.newReport.header, header)
  })
}

export const addJointToNewReport = function (state, joint) {
  if (state.newReport.selectedJointIds.indexOf(joint.joint_id) !== -1) {
    return
  }
  var joints = state.newReport.selectedJoints.slice()
  joints.push(joint)
  var ids = state.newReport.selectedJointIds.slice()
  ids.push(joint.joint_id)
  state.newReport = Object.assign({}, state.newReport, {
    selectedJoints: joints,
    selectedJointIds: ids
  })
}

export const addMultipleJointsToNewReport = function (state, joints) {
  var currentJoints = state.newReport.selectedJoints.slice()
  var currentIds = state.newReport.selectedJointIds.slice()
  joints.forEach(function (joint) {
    if (currentIds.indexOf(joint.joint_id) === -1) {
      currentJoints.push(joint)
      currentIds.push(joint.joint_id)
    }
  })
  state.newReport = Object.assign({}, state.newReport, {
    selectedJoints: currentJoints,
    selectedJointIds: currentIds
  })
}

export const removeJointFromNewReport = function (state, jointId) {
  var joints = state.newReport.selectedJoints.filter(function (j) {
    return j.joint_id !== jointId
  })
  var ids = state.newReport.selectedJointIds.filter(function (id) {
    return id !== jointId
  })
  var details = Object.assign({}, state.newReport.jointDetails)
  delete details[jointId]
  // Unmatched field-mode rows live in their own array keyed by 'field_'+rowId;
  // strip them too or they'll reappear.
  var unmatched = (state.newReport.unmatchedRows || []).filter(function (r) {
    return r.joint_id !== jointId
  })
  state.newReport = Object.assign({}, state.newReport, {
    selectedJoints: joints,
    selectedJointIds: ids,
    jointDetails: details,
    unmatchedRows: unmatched
  })
}

export const clearSelectedJoints = function (state) {
  state.newReport = Object.assign({}, state.newReport, {
    selectedJoints: [],
    selectedJointIds: [],
    jointDetails: {}
  })
}

export const clearNewReport = function (state) {
  state.newReport = {
    id: null,
    currentStep: 1,
    header: {
      name: '',
      address: '',
      city: '',
      bestallare: '',
      customerProject: '',
      sub_contractor: '',
      etapp: '',
      coil_to: '',
      isolation_to: '',
      coil_from: '',
      isolation_from: '',
      coil_twin: '',
      isolation_twin: '',
      alarm_connected: false,
      had_blueprint: false,
      density_test: false,
      discrepancy_report: false
    },
    selectedJoints: [],
    selectedJointIds: [],
    jointDetails: {},
    unmatchedRows: [],
    customerConfig: state.newReport.customerConfig
  }
}

export const setNewReportId = function (state, id) {
  state.newReport = Object.assign({}, state.newReport, { id: id })
}

export const setCustomerConfig = function (state, config) {
  state.newReport = Object.assign({}, state.newReport, { customerConfig: config })
}

export const loadReport = function (state, report) {
  var header = {
    name: report.name || '',
    address: report.address || '',
    city: report.city || '',
    bestallare: report.bestallare || '',
    customerProject: report.customer_project || '',
    sub_contractor: report.sub_contractor || '',
    etapp: report.etapp || '',
    coil_to: report.coil_to || '',
    isolation_to: report.isolation_to || '',
    coil_from: report.coil_from || '',
    isolation_from: report.isolation_from || '',
    coil_twin: report.coil_twin || '',
    isolation_twin: report.isolation_twin || '',
    alarm_connected: !!report.alarm_connected,
    had_blueprint: !!report.had_blueprint,
    density_test: !!report.density_test,
    discrepancy_report: !!report.discrepancy_report
  }

  var jointDetails = {}
  var selectedJointIds = []
  var unmatchedRows = []
  if (report.rows) {
    report.rows.forEach(function (row) {
      var toBool = function (v) { return v === null || v === undefined ? null : !!v }
      var rowDetails = {
        welding: toBool(row.welding),
        insulation: toBool(row.insulation),
        alarm_connected: toBool(row.alarm_connected),
        alarm_tested: toBool(row.alarm_tested),
        pressure_tested: toBool(row.pressure_tested),
        visual_inspection: toBool(row.visual_inspection),
        note: row.note || '',
        drawing_no: row.drawing_no || '',
        dimension_override: row.dimension_override || '',
        resistance_alarm: row.resistance_alarm || '',
        resistance_insulation: row.resistance_insulation || '',
        installer: row.installer || '',
        type: row.type || 'TSC'
      }

      if (row.joint_id) {
        if (selectedJointIds.indexOf(row.joint_id) !== -1) return
        selectedJointIds.push(row.joint_id)
        rowDetails._rowId = row.id
        rowDetails._images = row.images || []
        if (row.field_weld_id) {
          rowDetails._fromFieldMode = true
          rowDetails._fieldWeldId = row.field_weld_id
        }
        jointDetails[row.joint_id] = rowDetails
      } else {
        // Unmatched field-mode row — keyed by 'field_' + row.id
        var key = 'field_' + row.id
        selectedJointIds.push(key)
        jointDetails[key] = rowDetails
        unmatchedRows.push({
          _unmatched: true,
          _rowId: row.id,
          _fieldWeldId: row.field_weld_id || '',
          joint_id: key,
          images: row.images || []
        })
      }
    })
  }

  var selectedJoints = []
  if (report.joints && Array.isArray(report.joints)) {
    selectedJoints = report.joints
  }

  state.newReport = Object.assign({}, state.newReport, {
    id: report.id,
    status: report.status || 1,
    header: header,
    selectedJoints: selectedJoints,
    selectedJointIds: selectedJointIds,
    jointDetails: jointDetails,
    unmatchedRows: unmatchedRows
  })
}

export const updateUnmatchedRowWeldId = function (state, payload) {
  var rows = state.newReport.unmatchedRows || []
  for (var i = 0; i < rows.length; i++) {
    if (rows[i]._rowId === payload.rowId) {
      rows[i]._fieldWeldId = payload.fieldWeldId
      break
    }
  }
}

export const setNewReportStatus = function (state, status) {
  state.newReport = Object.assign({}, state.newReport, { status: status })
}

export const setJointDetail = function (state, payload) {
  var details = Object.assign({}, state.newReport.jointDetails)
  if (!details[payload.jointId]) {
    details[payload.jointId] = { welding: null, insulation: null, alarm_connected: null, alarm_tested: null, pressure_tested: null, visual_inspection: null, note: '', drawing_no: '', dimension_override: '', resistance_alarm: '', resistance_insulation: '', installer: '', type: 'TSC' }
  }
  details[payload.jointId] = Object.assign({}, details[payload.jointId], {
    [payload.field]: payload.value
  })
  state.newReport = Object.assign({}, state.newReport, { jointDetails: details })
}

export const addJointImage = function (state, payload) {
  var jointId = payload.jointId
  var image = payload.image
  if (!image) return
  var details = Object.assign({}, state.newReport.jointDetails)
  var current = details[jointId]
  if (!current) return
  var images = (current._images || []).filter(function (img) {
    return img.field_name !== image.field_name
  })
  images.push(image)
  details[jointId] = Object.assign({}, current, { _images: images })
  state.newReport = Object.assign({}, state.newReport, { jointDetails: details })
}

export const setAllJointDetails = function (state, payload) {
  var details = Object.assign({}, state.newReport.jointDetails)
  state.newReport.selectedJointIds.forEach(function (id) {
    if (!details[id]) {
      details[id] = { welding: null, insulation: null, alarm_connected: null, alarm_tested: null, pressure_tested: null, visual_inspection: null, note: '', drawing_no: '', dimension_override: '', resistance_alarm: '', resistance_insulation: '', installer: '', type: 'TSC' }
    }
    details[id] = Object.assign({}, details[id], { [payload.field]: payload.value })
  })
  state.newReport = Object.assign({}, state.newReport, { jointDetails: details })
}

export const setFieldWorkActiveReport = function (state, reportId) {
  state.fieldWork = Object.assign({}, state.fieldWork, { activeReportId: reportId })
}

export const setFieldWorkEditingRow = function (state, rowId) {
  state.fieldWork = Object.assign({}, state.fieldWork, { editingRowId: rowId })
}

export const addFieldWorkReport = function (state, report) {
  var reports = state.fieldWork.reports.slice()
  reports.push(report)
  state.fieldWork = Object.assign({}, state.fieldWork, { reports: reports })
}

export const addFieldWorkRow = function (state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.slice()
      rows.push(payload.row)
      return Object.assign({}, r, { rows: rows })
    }
    return r
  })
  state.fieldWork = Object.assign({}, state.fieldWork, { reports: reports })
}

export const updateFieldWorkRow = function (state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.map(function (row) {
        if (row.id === payload.rowId) {
          return Object.assign({}, row, payload.data)
        }
        return row
      })
      return Object.assign({}, r, { rows: rows })
    }
    return r
  })
  state.fieldWork = Object.assign({}, state.fieldWork, { reports: reports })
}

export const removeFieldWorkRow = function (state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.filter(function (row) {
        return row.id !== payload.rowId
      })
      return Object.assign({}, r, { rows: rows })
    }
    return r
  })
  state.fieldWork = Object.assign({}, state.fieldWork, { reports: reports })
}

export const setFieldWorkRowInvalid = function (state, payload) {
  if (!payload.invalidWeldIds || payload.invalidWeldIds.length === 0) return
  var invalidSet = {}
  payload.invalidWeldIds.forEach(function (id) { invalidSet[id] = true })
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.map(function (row) {
        return Object.assign({}, row, { invalid: !!invalidSet[row.weldId] })
      })
      return Object.assign({}, r, { rows: rows })
    }
    return r
  })
  state.fieldWork = Object.assign({}, state.fieldWork, { reports: reports })
}

export const setFieldWorkReportBackendId = function (state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.localId) {
      return Object.assign({}, r, { backendId: payload.backendId })
    }
    return r
  })
  state.fieldWork = Object.assign({}, state.fieldWork, { reports: reports })
}

export const setFieldWorkRowBackendIds = function (state, payload) {
  var reports = state.fieldWork.reports.map(function (r) {
    if (r.id === payload.reportId) {
      var rows = r.rows.map(function (row) {
        if (payload.rowIdMap[row.id] !== undefined) {
          return Object.assign({}, row, { backendRowId: payload.rowIdMap[row.id] })
        }
        return row
      })
      return Object.assign({}, r, { rows: rows })
    }
    return r
  })
  state.fieldWork = Object.assign({}, state.fieldWork, { reports: reports })
}

export const clearFieldWork = function (state) {
  state.fieldWork = {
    reports: [],
    activeReportId: null,
    editingRowId: null
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js